export const MODEL_TYPE_OBJECT = 'MODEL_TYPE_OBJECT';
export const MODEL_TYPE_NESTED_LIST = 'MODEL_TYPE_NESTED_LIST';
export const MODEL_TYPE_LIST = 'MODEL_TYPE_LIST';
export const MODEL_TYPE_DATE = 'MODEL_TYPE_DATE';

const user = { resource: 'users', type: MODEL_TYPE_OBJECT };
const role = { resource: 'roles', type: MODEL_TYPE_OBJECT };

export const userRoleDescriptor = {
    user,
    role,
}

const country = { resource: 'countries', type: MODEL_TYPE_OBJECT };

export const institutionDescriptor = {
    resource: 'institutions',
    type : MODEL_TYPE_OBJECT,
    readOnly: true,
    country : country,
}

const rootTermTypeDescriptor = {
    resource: 'rootTermTypes',
    type: MODEL_TYPE_OBJECT
};

export const rootTermDescriptor = {
    resource: 'rootTerms',
    type : MODEL_TYPE_OBJECT,
    readOnly: true,
    rootTermType : rootTermTypeDescriptor,
}

export const nationalTermDescriptor = {
    resource: 'nationalTerms',
    type : MODEL_TYPE_OBJECT
}